import { Table } from "antd";
import styled from "styled-components";

import color from "../_style/color";

export default styled(Table).attrs((props) => ({
  pagination: props.pagination || false,
  showHeader: props.showHeader || false,
}))`
  margin-left: 10px;

  .ant-table-tbody > tr > td {
    padding: 5px;
    border-bottom: 1px solid ${color.component};
  }

  .ant-table-tbody > tr > td:hover {
    background-color: unset;
  }

  .active > td > a {
    color: ${color.primary};
  }
`;
